"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var index_exports = {};
module.exports = __toCommonJS(index_exports);
__reExport(index_exports, require("./themes"), module.exports);
__reExport(index_exports, require("./tokens"), module.exports);
__reExport(index_exports, require("./componentThemeDefinitions"), module.exports);
__reExport(index_exports, require("./palettes"), module.exports);
__reExport(index_exports, require("@tamagui/colors/legacy"), module.exports);
__reExport(index_exports, require("./templates"), module.exports);
__reExport(index_exports, require("./shadows"), module.exports);
__reExport(index_exports, require("@tamagui/theme-builder"), module.exports);
//# sourceMappingURL=index.js.map
